<div class="margin">
    <app-home-faq-reduced [page]="'innovation'"></app-home-faq-reduced>
</div>